module.exports = __webpack_public_path__ + "assets/img/icon_warning_empty.4220e1e8.png";